import { createApp } from '@app/adapters/create-app'

import CompanyUsersV2 from '../../company-users-v2/components/company-users'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='company_users_v2']").each(function () {
    createApp(CompanyUsersV2, {
      isRelaxedLayout: this.dataset.relaxedLayout === 'true',
      pulsePresets: JSON.parse(this.dataset.pulsePresets),
    }).mount(this)
  })
})
